import React from "react";

/* 
 * 
 * Prepends // before content
 * 
 */
export const HeaderLink2 = (props) => <b className={`${props.className} header-link`}>
  <span>//</span><b>{props.text}</b>
</b>;